export default __webpack_public_path__ + "static/warning-messages-confirm-do-a78367f5f24e9966d6c00eec2020370f.png";